import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  COLUMNS_COUNT,
  COLUMNS_HEIGHT,
  WIDGET_MAX_WIDTH
} from 'shared/constants';

const propsSchema = [
  {
    key: 'theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'columnCount',
    label: 'Column Count',
    type: types.ENUM,
    options: COLUMNS_COUNT
  },
  {
    key: 'columnHeight',
    label: 'Column Height',
    type: types.ENUM,
    options: COLUMNS_HEIGHT
  },
  {
    key: 'columnMaxWidth',
    label: 'Column Max Width',
    type: types.ENUM,
    options: WIDGET_MAX_WIDTH
  },
  {
    key: 'margin',
    label: 'Top/Bottom Margin',
    type: types.OBJECT,
    children: [
      {
        key: 'marginTop',
        label: 'Add 10px white margin on top',
        type: types.BOOLEAN
      },
      {
        key: 'marginBottom',
        label: 'Add 10px white margin on bottom',
        type: types.BOOLEAN
      }
    ]
  }
];

const defaultProps = {
  theme: COMPONENT_COLOR_THEMES[0],
  columnCount: COLUMNS_COUNT[0],
  columnHeight: COLUMNS_HEIGHT[0],
  columnMaxWidth: '1200px',
  margin: {
    marginTop: false,
    marginBottom: false
  }
};

export default {
  title: 'Columns',
  id: 'Columns',
  propsSchema,
  defaultProps
};
